const RGB = {
  blue: "29,161,255",
  warm: "255,198,30",
} as const;

type GlowBlobProps = {
  /** Absolute offsets, e.g. { top: -230, right: -170 }. */
  position: React.CSSProperties;
  size: number;
  color?: keyof typeof RGB;
  /** Centre opacity. Every blob in the reference uses a different one. */
  alpha: number;
  /** Where the gradient reaches full transparency, e.g. "62%". */
  falloff: string;
  animated?: boolean;
  duration?: "normal" | "slow";
};

/**
 * Ambient glow. On the page canvas it is clipped by DarkCanvas rather than by
 * the section, which is what lets it bleed across section boundaries; inside a
 * dark panel the panel's own overflow clips it.
 *
 * Decorative and non-interactive: pointer-events none, aria-hidden, and the
 * breathing is motion-safe only.
 */
export function GlowBlob({
  position,
  size,
  color = "blue",
  alpha,
  falloff,
  animated = false,
  duration = "normal",
}: GlowBlobProps) {
  const motion = !animated
    ? ""
    : duration === "slow"
      ? "motion-safe:animate-glow-slow"
      : "motion-safe:animate-glow";

  return (
    <div
      aria-hidden="true"
      style={{
        ...position,
        width: size,
        height: size,
        backgroundImage: `radial-gradient(circle,rgba(${RGB[color]},${alpha}),transparent ${falloff})`,
      }}
      className={`pointer-events-none absolute rounded-full ${motion}`}
    />
  );
}
